import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import NebulaModuleBase from './module-base';
export var UpWifi = function (_NebulaModuleBase) {
    _inherits(UpWifi, _NebulaModuleBase);

    function UpWifi() {
        _classCallCheck(this, UpWifi);

        return _possibleConstructorReturn(this, (UpWifi.__proto__ || Object.getPrototypeOf(UpWifi)).apply(this, arguments));
    }

    _createClass(UpWifi, [{
        key: 'getCurrentRouterInfo',
        value: function getCurrentRouterInfo() {
            return this.generatePromiseByFunctionWithParams('getWifiInfoForWifiPlugin', null);
        }
    }, {
        key: 'jumpSystemWifiSetting',
        value: function jumpSystemWifiSetting() {
            return this.generatePromiseByFunctionWithParams('jumpSettingForWifiPlugin', null);
        }
    }, {
        key: 'getScanRouterList',
        value: function getScanRouterList(params) {
            return this.generatePromiseByFunctionWithParams('scanWifiInfoForWifiPlugin', params);
        }
    }]);

    return UpWifi;
}(NebulaModuleBase);